import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';

interface IPasswordToggleBtnProps {
  onTogglePassword: () => void;
  isPasswordVisible: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This renders an icon for when the password is hidden & a slash eye when it's
 * visible.Clicking on this Icon toggles the password to either masked or text.
 */
export function PasswordToggleBtn({
  onTogglePassword,
  isPasswordVisible,
}: IPasswordToggleBtnProps) {
  return (
    <button
      className="focus:outline-hidden focus:border-primary-100 focus:text-primary-900 focus:ring-primary-100 active:text-primary-900 z-20 mx-1
        h-5 w-5
        shrink-0 cursor-pointer rounded-lg
        text-gray-400 transition-all duration-500
        focus:ring-1 focus:ring-offset-4
        active:scale-50 rtl:left-2
        rtl:right-auto
      "
      onClick={onTogglePassword}
      type="button"
    >
      {isPasswordVisible ? <EyeSlashIcon /> : <EyeIcon />}
    </button>
  );
}
